import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { EmitterService } from '../../../../shared/services/emitter.service';
import { ReportService } from '../../../../services/reportAlert/report.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConstants } from '../../../../shared/constants/app.contants';
import { CameraService } from '../../../../services/camera/camera.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MessageSeverity, AlertService } from 'src/app/shared/services/alert.service';
import * as FileSaver from 'file-saver';
import { PanelCameraModalComponent } from 'src/app/shared/components/modals/panel/camera/panel-camera-modal.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import {DateAdapter, MAT_DATE_FORMATS} from '@angular/material';
import { APP_DATE_FORMATS, AppDateAdapter } from 'src/app/shared/helpers/format-datepicker';
import { LOCALE_ID } from '@angular/core';
import { ZoneService } from 'src/app/services/zone/zone.service';
import { Router } from '@angular/router';
import { ReportViewModel } from 'src/app/models/reportAlert/report';
import { EnterpriseAlertService } from 'src/app/services/enterprise-alert/enterpriseAlert.service';
import { CameraAlert, OcurrenceCamera } from 'src/app/models/alert/alert';
import * as XLSX from 'xlsx';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-report-va-alert',
  templateUrl: './report-va-alert.component.html',
  styleUrls: ['./report-va-alert.component.css'],
  providers: [
    {provide: DateAdapter, useClass: AppDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
  ]
})
export class ReportVAAlertComponent implements OnInit {

  loading: boolean = false;
  dataSource = new MatTableDataSource<CameraAlert>();
  displayedColumns: string[] = ['camera', 'typeAlert',  'insertDateOcurrence', 'enabled', 'userName', 'insertDate',  'action']; //'updateCamera',
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  subscription: Subscription;
  alertError = 0;

  cameras = [];
  users = [];
  cameraAlert = [];
  stats = [
    {
      id: 1, name: 'Pendiente'
    },
   /* {
      id: 2, name: 'En Proceso'
    }, */
    {
      id: 2, name: 'Atendido'
    }
  ];
  enterprises = [];
  enterpriseSelect: number;
  cameraSelect: number =  0;
  userSelect: number = 0;
  statuselect: number = 0;

  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 0;
  length: number = 0;

  reportForm: FormGroup;

  myDate = new Date();
  zoneId: number = 0;
  date = new Date();
  dateF = new Date();
  timeI: string;
  timeF: string;
  dateV:string;
  isAdministrator=false;
  dateIView:string;
  dateFView:string;
  headquarterSelect = 0;
  enterprisesZones = [];
  enterpriseZoneSelect: number = 0;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  enabledRead: number;
  enabledWrite: number;
  showUser = false;
  pageItems = 10;
  page = 1;
  filter = false;
  alertSelect = 0;
   filterData: any = {
    dateI: 0,
    dateF: 0,
    timeI: 0,
    timeF: 0,
    zoneId: 0,
    alertId: 0,
    cameraId: 0,
    page: 1,
    item: 10,
  };
   cameraTag = "0";

  currentPageIndex = 0;
  currentPageSize = 12;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private spinner: NgxSpinnerService,
    private ReportService: ReportService,
    private userService: UserService,
    private enterpriseService: EnterpriseService,
    private CameraService: CameraService,
    private enterpriseAlertService: EnterpriseAlertService,
    private datePipe: DatePipe,
    private AlertService: AlertService,
    private zoneService: ZoneService,
    private formBuilder: FormBuilder,) {
      document.getElementById("titleHeaderNav").innerHTML = 'Video Analítica > <span class="font-weight-bold">Reportes</span>';
    }

  ngOnInit() {
    this.setLS();
    this.createForm();
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.getZonesByEnterprise();
    this.getCameraTypesAndCategories();
    this.userList();
    this.timeI = this.datePipe.transform("Tue Aug 18 2020 00:00:58 GMT-0500", 'HH:mm');
    this.timeF = this.datePipe.transform("Tue Aug 18 2020 23:59:58 GMT-0500", 'HH:mm');
    this.dateV = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');

    this.dataSource = new MatTableDataSource<CameraAlert>([]);
  }

  ngAfterViewInit() {
    // No conectar el datasource al paginador
  }

  setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  getZonesByEnterprise() {
    this.enterprisesZones = [];
    this.spinner.show();
    this.zoneService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe(response => {
      if(response.error == null){
        var zones = response.data.filter(_ => _.type == 1);
        this.enterprisesZones = zones;
        if(this.enterprisesZones.length>0){
          this.enterpriseZoneSelect = this.enterprisesZones[0]["id"];
        }else{
          this.AlertService.showMessage("No tiene zonas VA registradas, debes de crear una zona para usar este módulo", "", MessageSeverity.error);
        }
        this.changeZone(0);
      }else{
        this.enterprisesZones = [];
        this.cameras = [];
      }
      this.cameraList();
      this.spinner.hide();
    });
  }

  changeZone(e: any) {
    if(e != 0){
      this.enterpriseZoneSelect = e;
    }
    this.cameraList();
  }

  checkError(){
    if(!this.alertError){
      this.alertError = 1;
    }else{
      this.alertError = 0;
    }
  }

  createForm() {
    this.reportForm = this.formBuilder.group({
        zoneId: ['', [Validators.required]],
        enterpriseId: [''],
        startDateReport: ['', [Validators.required]],
        endDateReport: ['', [Validators.required]],
        startTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
        endTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
        statusReport: ['', [Validators.required]],
        cameraReport: ['', [Validators.required]],
        alertReport: ['', [Validators.required]],
        userReport: [''],
    });
  }

  _keyUp(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
      console.log(event.keyCode)
      if (charCode != 46 && charCode != 58 && charCode > 31
        && (charCode < 48 || charCode > 57)) {
        return false;
      }
  }

  get f() { return this.reportForm.controls; }

  cameraList() {
    this.cameras = [];
    var data = {
      idZone: this.enterpriseZoneSelect,
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect
    }
    this.CameraService.getCameraByZone(this.enterpriseZoneSelect).subscribe((response => {
      this.cameras = response;
      if(this.cameras.length>1){
        this.cameraSelect =0;
      }else if(this.cameras.length!=0){
        this.cameraSelect = this.cameras[0].cameraId;
        this.cameraTag = this.cameras[0].tag;
      }
      this.spinner.hide();
    }),
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  changeState(){
    if(this.statuselect == 1){
      this.showUser = false;
      this.userSelect = 0;
    }else{
      this.showUser = true;
    }
  }

  userList() {
    this.users = [];
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect
    };
    this.userService.getUserEnterpriseHeadquarters(filter).subscribe((response) => {
      if(response.error == null){
        this.users = this.users.concat(response.data);
      }
      this.userSelect = 0;
    },
      (error: HttpErrorResponse) => {
        this.loading = false;
      });
  }

  changeCameras() {
    var existCamera = this.cameras.filter(x => x.cameraId == this.cameraSelect);
    if(existCamera.length){
      this.cameraTag = existCamera[0].tag;
      this.cameraSelect = existCamera[0].cameraId;
    }else{
      this.cameraTag = "";
      this.cameraSelect = 0;
    }
  }


  getCameraTypesAndCategories() {
    this.enterpriseAlertService.getTypesOrCategoriesByEnterprise(this.enterpriseSelect).subscribe(
      (response) => {
        if(response.data != null){
          this.cameraAlert = response.data;
        }
      },
      (error: HttpErrorResponse) => {
        
      }
    );
  }

  exp() {
    // this.loading = true;//ruta no existe, activar cuando el servicio funcione
    this.ReportService.downloadFile(
      this.enterpriseSelect,
      this.datePipe.transform(this.date, 'dd-MM-yyyy'),
      this.datePipe.transform(this.dateF, 'dd-MM-yyyy'),
      this.timeI,
      this.timeF,
      this.statuselect,
      this.cameraSelect,
      0,//this.alertSelect,
      this.userSelect,
      this.alertError
    ).subscribe(
      (response) => {
        const data: Blob = new Blob([response], {
          type: response.type
        });
        FileSaver.saveAs(data, 'archivo');
        this.loading=false;
      },
      (error) => {
        this.loading = false;
        this.AlertService.showMessage(AppConstants.TitleModal.DOWNLOAD_FILES, AppConstants.MessageModal.DOWNLOAD_FILE_MESSAGE, MessageSeverity.error);
      },()=>{this.loading=false;}
    );
  }

  setData(){
    let search = this.reportForm.value;
    try{
      this.dateIView = search.startDateReport;//this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
      this.dateFView = search.endDateReport; //this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');
      // alert("try catch 2 - " + this.dateIView);
     // search.startDateReport = this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
     // search.endDateReport = this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');
    }catch{
      this.dateIView = search.startDateReport;
      this.dateFView = search.endDateReport;

      search.startDateReport = search.startDateReport;
      search.endDateReport = search.endDateReport;
    }

  }

  setDatas(){
    let search = this.reportForm.value;

    this.dateIView = this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
    this.dateFView = this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');

   // search.startDateReport = this.datePipe.transform(search.startDateReport, 'dd/MM/yyyy');
   // search.endDateReport = this.datePipe.transform(search.endDateReport, 'dd/MM/yyyy');

  }
  
    alerta(id, id1, index, alert) {
      var alerts = this.dataSource.data.length;
      var beforeId = 0, afterId = 0, indexB = 0, indexA = 0, newAfterId = index + 1, newBefore = index - 1;
      if(index > 0){
        beforeId = this.dataSource.data[newBefore].alertId;
        indexB = newBefore;
        if(alerts > (index+1)){
          afterId = this.dataSource.data[newAfterId].alertId;
          indexA = newAfterId;
        }
      }else{
        if(alerts > (index+1)){
          afterId = this.dataSource.data[newAfterId].alertId;
          indexA = newAfterId;
        }else{
          indexA = 0;
          indexB = newBefore;
        }
      }
      let dialogRef = this.dialog.open(PanelCameraModalComponent, {
        data: {
          color: this.color2,
          ocurrenceId: id,
          cameraId: id1,
          enterpiseId: this.enterpriseSelect,
          alert: alert,
          beforeId: beforeId,
          afterId: afterId
        },
        width: '800px',
        hasBackdrop: true,
      });
  
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.update) {
          // Refresca toda la lista desde el backend
          this.searchAlerts();
        } else if (result && result.newId > 0) {
          // Navegación entre alertas usando la data ya cargada
          var i = (result.newId == afterId ? indexA : indexB);
          this.alerta(result.newId, this.dataSource.data[i].cameraId, i, this.dataSource.data[i]);
        }
      });
    }

     searchAlerts() {
      if (this.reportForm.valid) {
        this.filter = true;
        if (this.paginator) {
          this.paginator.firstPage();
          this.currentPageIndex = 0;
          this.currentPageSize = this.paginator.pageSize;
        } else {
          this.currentPageIndex = 0;
          this.currentPageSize = 12; // o tu valor por defecto
        }
        this.search();
      } else {
        this.reportForm.markAllAsTouched();
      }
    }

    handlePaginator(event: PageEvent) {
      this.currentPageIndex = event.pageIndex;
      this.currentPageSize = event.pageSize;
      this.search(event,true);
    }

    search(event?: PageEvent, isPaginator?: boolean) {
      this.spinner.show();
      const pageIndex = event ? event.pageIndex : this.currentPageIndex;
      const pageSize = event ? event.pageSize : this.currentPageSize;

      const payload = {
        enterpriseId: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        dateI: this.datePipe.transform(this.reportForm.value['startDateReport'], 'yyyy-MM-dd'),
        dateF: this.datePipe.transform(this.reportForm.value['endDateReport'], 'yyyy-MM-dd'),
        timeI: this.timeI,
        timeF: this.timeF,
        cameraTag: this.cameraTag,
        alertType: this.alertSelect,
        stateId: this.statuselect,
        cameraId: this.cameraSelect,
        userId: this.userSelect,
        error: this.alertError,
        zoneId: this.enterpriseZoneSelect,
        page: pageIndex + 1,
        pageItems: pageSize
      };

      this.enterpriseAlertService.GetReportAlertPanel(payload).subscribe(
        (response) => {
          if (response && response.data && response.data.length > 0) {
            this.dataSource.data = response.data;
            this.length = response.totalItems;
            if (this.paginator) {
              this.paginator.length = response.totalItems;
              this.paginator.pageIndex = pageIndex;
              this.paginator.pageSize = pageSize;
            }
          } else {
            this.dataSource.data = [];
            this.length = 0;
            if (this.paginator) {
              this.paginator.length = 0;
              this.paginator.pageIndex = 0;
            }
            this.AlertService.showMessage(
              AppConstants.TitleModal.WARNING_TITLE,
              AppConstants.MessageModal.DATA_NULL_SEARCH,
              MessageSeverity.error
            );
          }
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
          this.dataSource.data = [];
          this.length = 0;
          if (this.paginator) {
            this.paginator.length = 0;
            this.paginator.pageIndex = 0;
          }
        }
      );
    }

  exportToExcel(): void {
    // Construir el mismo payload que search()
    const payload = {
      enterpriseId: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
      dateI: this.datePipe.transform(this.reportForm.value['startDateReport'], 'yyyy-MM-dd'),
      dateF: this.datePipe.transform(this.reportForm.value['endDateReport'], 'yyyy-MM-dd'),
      timeI: this.timeI,
      timeF: this.timeF,
      cameraTag: this.cameraTag,
      alertType: this.alertSelect,
      stateId: this.statuselect,
      cameraId: this.cameraSelect,
      userId: this.userSelect,
      error: this.alertError
    };

    // Llamar al endpoint de exportación (debe existir en el servicio/backend)
    // Reemplaza 'GetReportAlertPanelExcel' por el nombre real del método si es diferente

      this.enterpriseAlertService.GetReportAlertPanelExport(payload).subscribe(
        (response: any) => {
          const data: Blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(data, 'alertas.xlsx');
        },
        (error) => {
          this.AlertService.showMessage('Error', 'No se pudo exportar el archivo', MessageSeverity.error);
        }
      );
  }
} 
